import React, { FC, useEffect } from 'react';
import { Box, Button, IconButton, Popover } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './PopoverComponent.module.scss';

interface PopoverComponentProps {
    children?: React.ReactNode;
}

const PopoverComponent: FC<PopoverComponentProps> = (props) => {
    const { children } = props;
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        if (open) {
            document.documentElement.classList.add('no-scroll-popover');
        } else {
            document.documentElement.classList.remove('no-scroll-popover');
        }

        return () => {
            document.documentElement.classList.remove('no-scroll-popover');
        };
    }, [open]);

    return (
        <div
            className={styles.PopoverComponent}
            data-testid="PopoverComponent"
        >
            <IconButton
                onClick={handleClick}
            >
                <InfoOutlinedIcon />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 3, maxWidth: '406px' }}>
                    {children}
                </Box>
                <Box sx={{ py: 2, px: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="text"
                        size="medium"
                        onClick={handleClose}
                    >
                        OK
                    </Button>
                </Box>
            </Popover>
        </div>
    );
};

export default PopoverComponent;

PopoverComponent.defaultProps = {
    children: undefined,
};
